// OrderModal.js
import React from 'react';
import { Modal, Button, Form, Col } from 'react-bootstrap';

const OrderModal = ({
  openModal,
  handleClose,
  modelContent,
  orderData,
  invoiceAllowAmount,
  errors,
  deliBoxEnable,
  handoverName,
  setHandoverName,
  handoverMob,
  setHandoverMob,
  paymentFields,
  renderPaymentFields,
  addInput,
  closeNotes,
  setReason,
  handleCancelOrder,
  handleDeliveryConfirm,
  notesText,
  isSubmitting
}) => {
  let customerName = orderData.customerDetails?.name ?? '';
  let customerMob = orderData.customerDetails?.mobile ?? '';
  return (
    <Modal show={openModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{modelContent.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Col className="d-flex mb-2">
          <Col className="float-right">
            <b>Name:</b> <br /> {customerName}
          </Col>
          <Col className="float-right">
            <b>Mobile:</b> <br /> {customerMob}
          </Col>
          <Col className="float-right">
            <b>Order Amount:</b> <br /> {invoiceAllowAmount.toFixed(2)}
          </Col>
        </Col>
        <Form className="cancelForm">
          {errors.common && (
            <Form.Control.Feedback className="text-center fs-5" type="invalid">
              <b>{errors.common}</b>
            </Form.Control.Feedback>
          )}
          {deliBoxEnable && (
            <>
              <Form.Group className="mb-3" controlId="handoverName">
                <Form.Label>Hand over to Name</Form.Label>
                <Form.Control
                  type="text"
                  onChange={(e) => setHandoverName(e.target.value)}
                  value={handoverName}
                  isInvalid={!!errors.handoverName}
                />
              </Form.Group>
              <Form.Control.Feedback type="invalid">
                {errors.handoverName}
              </Form.Control.Feedback>
              <Form.Group className="mb-3" controlId="handoverMob">
                <Form.Label>Hand over to Mobile</Form.Label>
                <Form.Control
                  type="text"
                  onChange={(e) => setHandoverMob(e.target.value)}
                  value={handoverMob}
                  isInvalid={!!errors.handoverMob}
                />
              </Form.Group>
              <Form.Control.Feedback type="invalid">
                {errors.handoverMob}
              </Form.Control.Feedback>

              {paymentFields && renderPaymentFields()}
              <Button variant="info" className="mt-1" onClick={addInput}>
                + Add more Payment options
              </Button>
            </>
          )}
          <Form.Group className="mb-3" controlId="closeNotes">
            <Form.Label>{notesText}</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={closeNotes}
              onChange={setReason}
              isInvalid={!!errors.closeNotes}
            />
          </Form.Group>
          <Form.Control.Feedback type="invalid">{errors.closeNotes}</Form.Control.Feedback>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="primary"
          onClick={modelContent.handleChangeType === 'cancel' ? handleCancelOrder : handleDeliveryConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Processing...
            </>
          ) : (
            modelContent.buttonText
          )}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OrderModal;
